import {React, useState} from "react";
import { useDispatch } from "react-redux";
import { Button } from "primereact/button";
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';

import CopyToClipboard from "../../../../common/CopyToClipboard";
import FileViewModal from '../../../../common/FileViewModal'

import { raiseToast } from "../../../../services/redux/reducers/toast/toast";
import { cancelBuyerQuote } from "../../../../services/api/buyerQuote";
import { getDocCopyByDocNo } from "../../../../services/api/docCopy";

import downloadFile from "../../../../utils/DownloadFile";
import { getBuyerProductName, getBuyerProductSpecification, getDateString, getProductQty, numberConversion } from "../../../../utils";

import { getPMCompanyConfig } from "../../../../setup/pmCompanyConfig";


const QuotationModalData = (props) => {
    const { selectedReq, setIsPageLoading, buyerQuote, activeBuyerPO, buyerQuoteItems, materialDetails, handleDeleteClick } = props

    const [buyerQuoteDeleteLoading, setBuyerQuoteDeleteLoading] = useState(false)
    const [buyerQuoteDocument, setBuyerQuoteDocument] = useState('')
    const [visibleDocument, setVisibleDocument] = useState(false)

    const pmCompanyConfig = getPMCompanyConfig(buyerQuote.pmCompanyId)
    let { numberLocale } = pmCompanyConfig

    const dispatch = useDispatch() 

    const accept = async () => {
        if (!activeBuyerPO){
            setBuyerQuoteDeleteLoading(true)
            const deleteBuyerQuoteRes = await cancelBuyerQuote(buyerQuote.buyerQuoteId)

            if (deleteBuyerQuoteRes?.failure){
                setBuyerQuoteDeleteLoading(false)
                dispatch(raiseToast({severity:'error', summary: 'deleteBuyerQuoteRes', detail: deleteBuyerQuoteRes.data.error, life: 3000}))
            }else{
                setBuyerQuoteDeleteLoading(false)
                handleDeleteClick({updatedBuyerQuote: deleteBuyerQuoteRes.data.updatedBuyerQuote, updatedBuyerQuoteItems: deleteBuyerQuoteRes.data.updatedBuyerQuoteItems})
            }
        }else {
            dispatch(raiseToast({severity:'error', detail: "This quotation has active buyer PO. Can't Delete the Quotation.", life: 3000}))
        }
    }

    const reject = () => {}

    const handleDelete = async (event) => {
        confirmPopup({
            target: event.currentTarget,
            message: `Are you sure you want to delete buyer quote ${buyerQuote?.docNo}?`,
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept,
            reject
        })
    }

    const viewBuyerQuotePDF = async () => {
        setIsPageLoading(true)
        const docCopyRes = await getDocCopyByDocNo(buyerQuote.docNo, true)
        if (docCopyRes?.failure){
            return dispatch(raiseToast({ severity: 'error', detail: docCopyRes?.data?.error }))
        }
        setIsPageLoading(false)
        // window.open(docCopyRes.docLocation, "_blank");
        setVisibleDocument(true)
        setBuyerQuoteDocument(docCopyRes.docLocation)
    }

    const downloadBuyerQuotePDF = async () => {
        setIsPageLoading(true)
        const docCopyRes = await getDocCopyByDocNo(buyerQuote.docNo, true)
        if (docCopyRes?.failure){
            return dispatch(raiseToast({ severity: 'error', detail: docCopyRes?.data?.error }))
        }
        setIsPageLoading(false)
        downloadFile(docCopyRes.docLocation, `Quote-${buyerQuote.docNo}.pdf`)
    }

    const handleBuyerQuoteView = () => {
        setVisibleDocument(false)
        setBuyerQuoteDocument('')
    }

    return(
        <div className={`p-card my-2 py-1 quotation-modal-data ${buyerQuote?.statusId === 6 ? 'cancelled-watermark' : ''}`}>
            <ConfirmPopup />
            <FileViewModal visible={visibleDocument} document={buyerQuoteDocument} handleOnHide={handleBuyerQuoteView} docName={buyerQuote.docNo} />
            <div className="grid">
                <div className="flex flex-row col-12 justify-content-between pb-0">
                    <div className="flex flex-row justify-content-start align-items-center col-12 md:col-5 lg:col-5 lg:mb-0 pl-0">
                        <h5 className="m-0 doc-no-navigation"> <span style={{fontWeight: "lighter"}}>Quote No:</span> {buyerQuote?.docNo}</h5>
                        {
                            buyerQuote?.docNo ? <CopyToClipboard text={buyerQuote?.docNo} /> : ""
                        }  
                        { buyerQuote?.validUpto ? <span className="ml-4">Valid Upto: <span className="font-semibold">{ getDateString(buyerQuote?.validUpto) }</span></span> : "" }
                    </div>
                    <div className="flex col-12 mb-2 md:col-3 lg:col-3 lg:mb-0 justify-content-start align-items-center">
                        <div><span>Total Price:</span>&nbsp;&nbsp;<span className="price-value font-semibold">{numberConversion(parseFloat(buyerQuote?.bQuotTotalItemAmountWithTax), numberLocale)}</span></div>
                    </div>
                    <div className="flex flex-row col-12 mb-2  md:col-4 lg:col-4 lg:mb-0 align-items-center justify-content-end pt-0">
                        <Button severity="success" rounded onClick={viewBuyerQuotePDF}>
                            <i className="pi pi-eye" style={{ fontSize: "0.9rem" }} />
                        </Button>
                        <Button className="bg-blue-300 border-blue-300" severity="success ml-2" rounded onClick={downloadBuyerQuotePDF}>
                            <i className="pi pi-download" style={{ fontSize: "0.9rem" }} />
                        </Button>
                    </div>
                </div>
            </div>
            <div className="dialog-table-container">
                <table className="dialog-table" style={{ width: "100%" }}>
                    <thead >
                        <tr className="">
                            <th className="" style={{ width: "5%"}}>SR</th>
                            <th className="" style={{ width: "20%"}}>PRODUCT</th>
                            <th className="" style={{ width: "10%"}}>HSN/SAC</th>
                            <th className="" style={{ width: "10%"}}>DELIVERY PERIOD</th>
                            <th className="" style={{ width: "35%"}}>SPECIFICATION</th>
                            <th className="" style={{ width: "10%"}}>QUANTITY</th>
                            <th className="" style={{ width: "10%"}}>TOTAL AMOUNT</th>
                        </tr>
                    </thead>
                    <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                        {
                            buyerQuoteItems?.map((eachBuyerQuoteItem, index) => {
                                const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === eachBuyerQuoteItem?.materialId)
                                // console.log("relatedMaterial", relatedMaterial)

                                return (
                                    <tr className="" key={`buyerQuoteItem-${eachBuyerQuoteItem.buyerQuoteItemId}`} style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                        <td className="" style={{ width: "5%"}}>{index + 1}</td>
                                        <td className="" style={{ width: "20%"}}>{getBuyerProductName(relatedMaterial?.companyProdName, relatedMaterial?.productName)}</td>
                                        <td className="" style={{ width: "10%"}}>{eachBuyerQuoteItem?.bQuotHSNCode}</td>
                                        <td className="" style={{ width: "10%"}}>{eachBuyerQuoteItem?.leadTime} Day(s)</td>
                                        <td className="" style={{ width: "35%"}}>{getBuyerProductSpecification(relatedMaterial?.companyProdSpec, relatedMaterial?.productSpecification, relatedMaterial?.UOM, relatedMaterial?.UOMValue)}</td>
                                        <td className="" style={{ width: "10%"}}>{getProductQty(eachBuyerQuoteItem?.totReqQty, relatedMaterial?.UOM, relatedMaterial?.UOMValue)}</td>
                                        <td className="" style={{ width: "10%"}}>{numberConversion(eachBuyerQuoteItem?.bQuoteItemAmountWithTax, numberLocale)}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default QuotationModalData;